import React from "react";
import { InputText } from "../../../components/InputText";
import { Button } from "../../../components/Button";
import VehicleRepository from "../../../repositories/VehicleRepository";
import { toastr } from "react-redux-toastr";
import { formatLicensePlate } from "../../../utils/normalize";

const SelectLicensePlate = ({
  values,
  errors,
  handleChange,
  trigger,
  nextPage,
  previousPage,
}) => {
  const handleNextPage = async () => {
    const isValid = await trigger(["licensePlate"]);
    if (!isValid) {
      toastr.error("Erro", "Por favor, corrija os erros antes de prosseguir.");
      return;
    }

    try {
      const vehicleData = await VehicleRepository.getVehicleData(
        values.licensePlate.replace("-", "")
      );

      if (vehicleData?.model && vehicleData?.brand) {
        handleChange("brand", {
          value: 0,
          label: vehicleData.brand,
        });
        handleChange("model", {
          value: 0,
          label: vehicleData.model,
        });
      } else {
        handleChange("brand", null);
        handleChange("model", null);
      }
      nextPage();
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
      toastr.error("Erro", "Não foi possível buscar os dados do veículo.");
      nextPage();
    }
  };

  return (
    <>
      <div style={{ textAlign: "center", alignItems: "center" }}>
        <h4 style={{ margin: 0 }}>
          <b>Placa do Veículo</b>
        </h4>
        <p style={{ fontSize: "small" }}>Informe a placa do seu veículo</p>
      </div>
      <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <InputText
          name="licensePlate"
          width="100%"
          value={values.licensePlate}
          onChange={(e) =>
            handleChange("licensePlate", formatLicensePlate(e.target.value))
          }
          onBlur={() => trigger(["licensePlate"])}
          maxLength={8}
          error={errors.licensePlate}
        />
      </div>
      <br />
      <div className="signup-form-div-buttons" style={{ width: "100%" }}>
        {previousPage && (
          <Button onClick={previousPage} color="red400" type="button">
            Voltar
          </Button>
        )}
        <Button onClick={handleNextPage} color="green450" type="button">
          Avançar
        </Button>
      </div>
    </>
  );
};

export default SelectLicensePlate;
